import { Vue, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import * as master from "@/store/modules/master/types";
import { User, MenuInfo } from "@/types";

@Component({})
export default class UtilMixin extends Vue {
  @State(master.name) masterState!: master.MasterState;

  public get loginUser(): User {
    return this.masterState.loginUser as User;
  }

  public get MenuInfo(): MenuInfo {
    return this.masterState.menuInfo as MenuInfo;
  }
}
